import { LOCALE } from '../locale/locale.consts';

export const getMonthTitle = date => date.toLocaleString(LOCALE, { month: 'long' });

export const isDateValid = date => date && !isNaN(date.getTime());
